import { PriceChange } from '@toggle/design-system';
import styled from 'styled-components';

const priceChangeColors = {
  default: 'var(--text-soft)',
  negative: 'var(--viz-bearish)',
  positive: 'var(--viz-bullish)',
};

export const PercentageChangeLabel = styled.div<{
  $status: PriceChange['status'];
}>`
  font-family: var(--font-roboto-mono);
  align-self: flex-end;
  color: ${props => priceChangeColors[props.$status]};
  font-size: 16px;
  font-weight: 500;
`;
